(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('CommunicateService', CommunicateService)

    /** @ngInject */
    function CommunicateService(HttpService) {
        const CommunicateService = {
            getAllByParameters: getAllByParameters,
            getById: getById,
            getByUrl: getByUrl,
            postAccessLog: postAccessLog
        }

        return CommunicateService;

        function getAllByParameters(params, personId) {
            return HttpService.get(`/communicates/parameters/${personId}`, {
                params
            });
        }

        function getById(id, personId) {
            return HttpService.get(`/communicates/${id}/${personId}`)
        }

        function getByUrl(url, personId, responsibilityId) {
            return HttpService.get(`/communicates/${personId}/${responsibilityId}/${url}`)
        }

        function postAccessLog(accessLogData) {
            return HttpService.post('/communicates/access-log', accessLogData);
        }
    }
}());